import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { ORDER_LIST_ORDER_STATUS_ICONS } from 'src/constants/filterConstants';
import { MainContainer } from 'src/common/components/collapsableCard/CollapsableCard.styled';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';

import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import {
    convertTime24To12,
    isMobileDevice,
    setCurrencyFormat,
} from 'src/utils/util';

import {
    InvoiceImageContainer,
    InvoiceDetailContainer,
    InvoiceTitleContainer,
    TitleContainer,
    InvoiceCreatedContainer,
    InvoiceCreatedDetail,
    InvoiceDataContainer,
    WrapperContainer,
    CardTitleText,
} from './OrderSummaryDetailsCard.styled';

import { InvoiceStatusPrice } from './OrderSummaryDetails.styled';

import {
    OrderTypeSpanContianer,
    OrderCountContainer,
    OrderCountSpan,
} from './OrderSummaryDetails.styled';
import { CollapsableCardRowHeader } from 'src/styles/CommonStyles.styled';

import TissueIcon from 'src/assets/images/TissueItemIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import { useTranslation } from 'react-i18next';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { OrderTypes } from 'src/constants/orderListConstants';
import { sizes } from 'src/styles/Media.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrderSummaryDetailsCard = ({
    onClick,
    children,
    title,
    isExpanded,
    padding,
}) => {
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));

    const [orderHeaderDetail, setOrderHeaderDetail] = useState([]);
    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    const [shippingStatusSVG, setShippingStatusSVG] = useState(null);
    // const orderSummaryDetail = useSelector(
    //     (state) =>
    //         state.orderSummaryReducer?.orderBasicDetails?.orderSummaryDetail
    // );

    // const { lastModifiedDate } = orderSummaryDetail || {};
    const { orderDescription, createdBy, createdByTime } = useSelector(
        (state) => ({
            orderDescription:
                state.orderSummaryReducer.orderBasicDetails?.orderDescription,
            createdBy: state.orderSummaryReducer.createdBy,
            createdByTime: state.orderSummaryReducer.createdByTime,
        })
    );

    useEffectWithErrorLogging(() => {
        if (createdBy && createdBy !== '' && createdByTime) {
            setModifyDate(getDisplayDate(new Date(createdByTime)));
            setModifyTime(convertTime24To12(new Date(createdByTime)));
        }
    }, [createdBy]);

    const shippingStatus = useSelector(
        (state) =>
            state.orderSummaryReducer.orderBasicDetails?.orderStatusDescription
    );
    const { iconList } = ORDER_LIST_ORDER_STATUS_ICONS();

    const isCondensedView = useSelector(
            (state) => state.loginReducer.isCondensedView
        );

    useEffectWithErrorLogging(() => {
        iconList.forEach((statusType) => {
            if (statusType.description === shippingStatus) {
                setShippingStatusSVG(statusType.filterIconUrl);
            }
        });
    }, [shippingStatus]);

    useEffectWithErrorLogging(() => {
        if (orderDescription && orderDescription?.length > 0) {
            const orderTypePrice = Array.from(
                new Set(
                    orderDescription
                        .filter(
                            (x) => x.orderType !== OrderTypes().REPLENISHMENT &&
                            x.orderType !== OrderTypes().MAST_REPLENISHMENT
                        )
                        .map((x) => x.salesOrg)
                )
            ).map((salesOrg) => {
                return {
                    salesOrg: salesOrg,
                    price: orderDescription
                        .filter((x) => x.salesOrg === salesOrg)
                        .reduce(
                            (prev, cur) =>
                                cur?.price && cur?.price !== ''
                                    ? parseFloat(prev) + parseFloat(cur.price)
                                    : prev + 0,
                            0
                        ),
                    count: orderDescription
                        .filter((x) => x.salesOrg === salesOrg)
                        .filter((x) => x.price > 0).length,
                };
            });

            setOrderHeaderDetail(orderTypePrice);
        }
    }, [orderDescription]);

    return (
        <MainContainer padding={padding} mobileMargin={isCondensedView ? '10px 16px 2px 16px' : ''}>
            <CollapsableCardRowHeader
            id="orders-ordersummary-details-card-header"
                onClick={onClick}
                isExpanded={isExpanded}
                flexDirection={'column'}
                mbHeaderWidth={'102%'}
                width={'100%'}
            >
                <InvoiceTitleContainer>
                    <InvoiceImageContainer
                        src={shippingStatusSVG}
                        alt={shippingStatus}
                        isOrder={'1'}
                        mbMargin={'0 0 0 -5px'}
                        smMargin={'0'}
                        style={{ width: '4%' }}
                    />
                    <TitleContainer mbDisplay={'flex'}>
                        <CardTitleText>{title}</CardTitleText>
                        {isMobileDevice() && (
                            <InvoiceImageContainer
                                src={DownArrowFilter}
                                alt="down-arrow"
                                isExpanded={isExpanded}
                                cursor={'pointer'}
                                display={'flex'}
                            />
                        )}
                    </TitleContainer>

                    <InvoiceCreatedContainer>
                        {createdBy || modifyDate || modifyTime ? (
                            <WrapperContainer>
                                <InvoiceCreatedDetail>
                                    {isLanguageChanged && createdBy
                                        ? ''
                                        : t('proxies.created')}
                                </InvoiceCreatedDetail>
                            </WrapperContainer>
                        ) : null}
                        <WrapperContainer width={'auto'}>
                            {createdBy ? (
                                <InvoiceCreatedDetail
                                    width={'100%'}
                                    whiteSpace={'nowrap'}
                                    overflow={'hidden'}
                                    textOverFlow={'ellipsis'}
                                >
                                    {isLanguageChanged
                                        ? t(
                                              'orders.orderDetails.billingSummary.createdby'
                                          )
                                        : t(
                                              'orders.orderDetails.billingSummary.by'
                                          )}
                                    <span className="orders-summary-created-by-dt-mask">{` ${createdBy?.split('*$*')[0]}`}</span>
                                </InvoiceCreatedDetail>
                            ) : null}
                        </WrapperContainer>
                        <WrapperContainer>
                            {modifyDate ? (
                                <InvoiceCreatedDetail isCreatedDate>
                                    {modifyDate}
                                </InvoiceCreatedDetail>
                            ) : null}
                            {modifyTime ? (
                                <InvoiceCreatedDetail
                                    margin={'0 1rem 0 0'}
                                    mobileMargin={'0'}
                                >
                                    {modifyTime} {getTimeZoneName()}
                                </InvoiceCreatedDetail>
                            ) : null}
                        </WrapperContainer>
                    </InvoiceCreatedContainer>
                    <InvoiceImageContainer
                        src={DownArrowFilter}
                        alt="down-arrow"
                        isExpanded={isExpanded}
                        cursor={'pointer'}
                        display={isMobileDevice() ? 'none' : 'flex'}
                    />
                </InvoiceTitleContainer>
                {!isExpanded ? (
                    <InvoiceDetailContainer mobileMarginLeft={'6px'}>
                        {orderHeaderDetail?.length > 0 ? (
                            <>
                                {orderHeaderDetail
                                    ?.filter(
                                        (x) =>
                                            // (x.salesOrg === 'S030' ||
                                            //     x.salesOrg === 'S002') &&
                                            x.price > 0
                                    )
                                    .map((orderHeaderValue) => {
                                        return (
                                            <>
                                                <InvoiceDataContainer
                                                    key={
                                                        orderHeaderValue?.salesOrg
                                                    }
                                                >
                                                    <OrderTypeSpanContianer
                                                        sourcePath={
                                                            orderHeaderValue.salesOrg ===
                                                            'S030'
                                                                ? TissueIcon
                                                                : orderHeaderValue.salesOrg ===
                                                                      'S002' &&
                                                                  NonTissueIcon
                                                        }
                                                    >
                                                        {orderHeaderValue?.count ? (
                                                            <OrderCountContainer>
                                                                <OrderCountSpan>
                                                                    {
                                                                        orderHeaderValue.count
                                                                    }
                                                                </OrderCountSpan>
                                                            </OrderCountContainer>
                                                        ) : null}
                                                    </OrderTypeSpanContianer>
                                                    {orderHeaderValue?.salesOrg ? (
                                                        <InvoiceStatusPrice
                                                            fontFamily="AvenirNextWorld Demi"
                                                            isPrice
                                                        >
                                                            {setCurrencyFormat(
                                                                orderHeaderValue.price
                                                            )}
                                                        </InvoiceStatusPrice>
                                                    ) : null}
                                                </InvoiceDataContainer>
                                            </>
                                        );
                                    })}
                            </>
                        ) : null}
                    </InvoiceDetailContainer>
                ) : null}
            </CollapsableCardRowHeader>
            {children}
        </MainContainer>
    );
};

export default OrderSummaryDetailsCard;
